import React from 'react';
import config from '../../config';
import { twitterPageURL } from '../../util/urlHelpers';
import { StaticPage, TopbarContainer } from '..';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
} from '../../components';
import css from './AugerBlogPage.module.css';

const AugerBlogPage = () => {
  const { siteTwitterHandle, siteFacebookPage } = config;
  const siteTwitterPage = twitterPageURL(siteTwitterHandle);

  return (
    <StaticPage
      title="Rent my Auger with Lenddit"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        description:
          'Discover why Lenddit is the perfect platform to rent out your idle auger, turning it into a consistent source of extra income.',
        name: 'Rent My Auger',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.staticPageWrapper}>
          <h1>Unlock the Potential of Your Auger with Lenddit</h1>
          <p>
            In the realm of construction and landscaping, the auger is an indispensable tool. Whether it's for drilling holes for fence posts, planting trees, or executing various construction projects, the auger is a must-have piece of equipment. But what happens when your auger is idle, gathering dust in your garage? That's where Lenddit comes in.
          </p>

          <h2>The Rise of the Equipment Rental Market</h2>
          <p>
            The equipment rental market has been on a steady rise over the years. According to a report by Grand View Research, the global equipment rental market is expected to reach an impressive USD 120.7 billion by 2027. This growth is primarily driven by the increasing demand for cost-effective solutions in the construction industry and the rising trend of renting instead of purchasing expensive equipment.
          </p>

          <h2>The Demand for Augers</h2>
          <p>
            Among various tools and equipment, augers hold a special place. They are essential for a wide range of projects, from small home improvements to large-scale construction jobs. However, augers can be expensive to purchase, especially for individuals or companies that only need them for a single project. This is where the concept of renting becomes an attractive and economical option.
          </p>

          <h2>Lenddit: Your Auger's New Best Friend</h2>
          <p>
            If you own an auger that's sitting idle, why not put it to work? By listing your auger on Lenddit, you can generate a consistent stream of extra income. It's a win-win situation: you monetize your idle equipment, and someone else gets to use the auger they need without the hefty price tag of buying one.
          </p>

          <h2>Why Choose Lenddit?</h2>
          <p>
            Lenddit is more than just a platform to rent out your equipment. It's a community that values resourcefulness and cost-effectiveness. Here's why you should consider Lenddit for your auger rental needs:
          </p>

          <ol>
            <li>Easy and Convenient: Listing your auger on Lenddit is a breeze. With a user-friendly interface, you can have your listing up and running in no time.</li>
            <li>Secure Transactions: Lenddit ensures secure transactions between the equipment owner and the renter. You can rest easy knowing that your interests are protected.</li>
            <li>Wide Reach: Lenddit's platform gives your auger exposure to a wide audience. This increases the chances of your equipment being rented out.</li>
            <li>Potential Earnings: Renting out your auger can be a significant source of income. Depending on the model and condition of your auger, you could earn a substantial amount over time. With the high demand for augers in various projects, your equipment could be rented out frequently, providing you with a steady income stream.</li>
          </ol>

          <p>
            Renting out your auger on Lenddit is not just about making extra money. It's about being part of a community that values resourcefulness and cost-effective solutions. So why wait? List your auger on Lenddit today and let your tool work for you!
          </p>
          <p>Written by: The Lenddit Team</p>
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

export default AugerBlogPage;
